import {
  CheckSlideStyleNameExistsDocument,
  CreateSlideStyleDocument,
  DeleteSlideStyleDocument,
} from "@/generated/graphql";
import { withToast } from "@/lib/utils/withToast";
import { useLazyQuery, useMutation } from "@apollo/client/react";

export function useSlideStyleMutations() {
  const [checkNameExists] = useLazyQuery(CheckSlideStyleNameExistsDocument);
  const [createSlideStyle, { loading: createStyleLoading }] = useMutation(
    CreateSlideStyleDocument,
    {
      update(cache, { data }) {
        if (!data?.createSlideStyle) return;

        const id = cache.identify(data.createSlideStyle);

        if (!id) return;

        cache.modify({
          fields: {
            getSlideStyles(existingData) {
              return {
                ...existingData,
                items: [{ __ref: id }, ...existingData.items],
                total: (existingData.total || 0) + 1,
              };
            },
          },
        });
      },
    }
  );

  const [deleteSlideStyleMutation, { loading: deleteStyleLoading }] = useMutation(
    DeleteSlideStyleDocument,
    {
      update(cache, { data }) {
        if (!data?.deleteSlideStyle) return;
        const id = cache.identify(data.deleteSlideStyle);
        if (id) {
          cache.evict({ id });
        }

        cache.gc();
      },
    }
  );

  const deleteSlideStyle = (id: string) => {
    withToast(
      async () => {
        const slideStyle = await deleteSlideStyleMutation({ variables: { id } });
        return slideStyle;
      },
      {
        loading: "Removing style...",
        error: "Failed to delete style",
        success: "Style deleted!",
      },
      "deleteStyleToast"
    );
  };

  return {
    checkNameExists,
    createSlideStyle,
    createStyleLoading,
    deleteSlideStyle,
    deleteStyleLoading,
  };
}
